import React, { useRef, useState, useEffect } from 'react';
import { Button, TextField, Grid } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Alert, Autocomplete } from '@mui/material';
import { useCopy } from 'hooks';
import { FormProvider, useForm } from 'react-hook-form';
import { validator } from 'myValidation';
import { checkContactSybscriptions } from '../../../DigitalAccount/ReceivedDelegationList/ReceivedDelegation/components/TransferDelegation/services/TransferDelegationServices';
import { getSubscriptionsRequest } from '../services/AssignedSubscriptionsServices';
import { SelectV, InputV2 } from 'components';
import { AutocompleteV } from 'components';
import { enifyDateTime } from 'utility';
import createToast from 'components/Toast/Toast';


import Services from '../../../RequestReceived/AllReceivedRequests/services/AllReceivedRequestsServices';
import _ from 'lodash';

const grantTypeOptions = [
  {
    value: 'cellphoneNumber',
    label: 'تلفن همراه',
    rules: ['isMobile'],
    englishNumber: true,
  },
  {
    value: 'username',
    label: 'نام کاربری',
    rules: ['isUsername'],
    englishNumber: true,
  },
  {
    value: 'businessId',
    label: ' شناسه کسب و کار',
    rules: ['isBusinessId'],
    englishNumber: true,
  },
];
const DEFAULT_GRANT_DATA_TYPE = 'cellphoneNumber';

export const DedicatedActivation = ({ id: planId, otherData = null, subscriptionType }, props) => {
  const { copyItem } = useCopy();
  const {
    singleSelect = false,
    selected = [],
    setSelected = () => {},
    className,
    style,
    children,
    name = 'businesses',
    // AutocompleteV props

    ...rest
  } = props;
  const methods = useForm();
  const [loading, setLoading] = useState(false);
  const [loadingAuth, setLoadingAuth] = useState(false);

  const [userContactInfo, setUserContactInfo] = useState(null);
  const [link, setLink] = useState('');
  const [message, setMessage] = useState('');
  const delayedQuery = useRef(_.debounce((v, f) => f(v), 500)).current;
  const [businessSearchText, setBusinessSearchText] = useState('');
  const [businesses, setBusinesses] = useState([]);
  const [fValue, setFValue] = useState(null);
  const [grantUserDataType, setGrantUserDataType] = useState(DEFAULT_GRANT_DATA_TYPE);
  const [incomingUserQuery, setIncomingUserQuery] = useState(null);
  const [redirectUri, setRedirectUri] = useState(null);
  const classes = useStyle();
  const { control, register, formState: { errors } } = methods;

  const getShareLink = async () => {
    const values = methods.getValues();
    const contactValue = grantUserDataType === 'businessId' ? fValue : values.contact;

    if (!String(contactValue ?? '').trim()) {
      return;
    }

    const types = {
      cellphoneNumber: 'phoneNumber',
      username: 'username',
      businessId: 'businessId',
    };

    let obj = {};
    if (grantUserDataType == 'cellphoneNumber') {
      if (
        String(values.contact).trim().length > 10 &&
        String(values.contact).trim()[0] == '0' &&
        String(values.contact).trim()[1] == '9'
      ) {
        const v = validator.matches(
          String(values.contact).trim() ?? '',
          /^((?:\+98|0)(\d){2}(\d){8})$/,
        );
        if (!v) return;
      } else {
    
        createToast( 'خطا' ,'شماره موبایل به درستی وارد نشده است', 'danger');

        return;
      }
    }
    if (grantUserDataType == 'businessId') {
      if (
        validator.matches(String(fValue).trim()) &&
        String(fValue).trim()[0] != '0' &&
        validator.matches(String(fValue).trim() ?? '', /^[1-9][0-9]*$/)
      ) {
        const v = validator.matches(String(fValue).trim());
        if (!v) return;
      } else {
 
        createToast( 'خطا' ,'شناسه کسب و کار به درستی وارد نشده است', 'danger');

        return;
      }
    }
    obj[types[grantUserDataType]] = String(contactValue).trim();
    setLoading(true);
    let searchContact = {};

    if (grantUserDataType == 'cellphoneNumber') {
      searchContact = { phoneNumber: userContactInfo };
    } else if (grantUserDataType == 'businessId') {
      searchContact = { businessId: fValue };
    } else {
      searchContact = { username: userContactInfo };
    }

    await checkContactSybscriptions(searchContact)
      .then(async (userSsoId) => {
        await getSubscriptionsRequest(planId, {
          userId: userSsoId?.result?.id,
          ssoId: userSsoId?.result?.ssoId,
          redirectUri: redirectUri,
        })
          .then((subscriptionLink) => {
            if (subscriptionLink?.result?.free) {
              // طرح رایگان
              setLink(null);
              setMessage('طرح به صورت رایگان برای کاربر فعال شد');
              return;
            }
            if (subscriptionType === 'SUBSCRIPTION_PLAN_TYPE_CASH') {
              //نقدی
              setLink(subscriptionLink?.result?.paymentLink);
              setMessage(null);
            } else if (subscriptionType === 'SUBSCRIPTION_PLAN_TYPE_BLOCK') {
              //مسدودی
              setLink(null);
              setMessage('پیامک فعال سازی برای کاربر ارسال شد');
            } else if (subscriptionType === 'SUBSCRIPTION_PLAN_TYPE_POST_PAID') {
              //پس پرداخت
              setLink(null);
              setMessage('طرح برای کاربر فعال خواهد شد');
            }
          })
          .catch((error) => {
      
          })
          .finally(() => {
            setLoading(false);
          });
      })
      .catch((error) => {
 
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    delayedQuery(businessSearchText, getAccounts);
  }, [businessSearchText]);
  const numberTester = new RegExp(/^[0-9]+$/); // regexp to test whether the text is number or not

  const getAccounts = async (searchValue) => {
    if (searchValue?.length >= 2) {
      setLoadingAuth(true);
      try {
        const q = {
          size: 20,
          offset: 0,
        };

        const val = enifyDateTime(searchValue);

        q[numberTester.test(val) ? 'businessId' : 'query'] = val;

        const result = await Services.getBusinessList(q);
        const data = result.result;
        let list = [];
        list = data.map((v) => ({
          name: v.name,
          id: v.id,
          label: `${v.name} (شناسه: ${v?.id})`,
          value: v.id,
        }));
        setBusinesses(list);
      } catch (e) {
      }
      setLoadingAuth(false);
    }
  };

  return (
    <>
      <Grid alignItems="center" container style={{ justifyContent: 'center' }}>
        {!message ? (
          <Grid xs={12} item style={{ marginBottom: 10 }}>
            <Alert severity="warning">
              <h3 className={classes.title}>توجه</h3>
              <div className={classes.textWrapper}>
                برای فعال سازی طرح بایستی حتما برای طرح مورد نظر آدرس بازگشت در نظر گرفته شود.
                درصورت عدم تائید آدرس بازگشت توسط تیم پشتیبانی این لینک به درستی کار نخواهد کرد.
              </div>
            </Alert>
          </Grid>
        ) : null}

        {message ? (
          <Grid xs={12} item style={{ marginBottom: 10 }}>
            <Alert severity="success">
              <div className={classes.textWrapper}>{message}</div>
            </Alert>
          </Grid>
        ) : null}

        {!link && !message ? (
          <>
            <Grid container spacing={2} xs={12}>
              <Grid item xs={12} md={6}>
                <SelectV
                  name="type"
                  options={grantTypeOptions}
                  label="نوع اطلاعات مخاطب"
                  control={control}
                  register={register}
                  rules={['required']}
                  required
                  onChangeFunc={(k, e) => {
                    setGrantUserDataType(e?.target?.value);
                    methods.setValue('contact', '');
                    setUserContactInfo('');
                  }}
                  defaultValue={grantUserDataType}
                  errors={errors}
                  disabled={incomingUserQuery?.userInfo}
                  fullWidth
                />
              </Grid>

              {grantTypeOptions.find((v) => v?.value === grantUserDataType)?.value ===
                'businessId' && (
                <Grid item xs={12} md={6} style={{ paddingTop: '8px' }}>
                  <AutocompleteV
                    control={methods?.control}
                    errors={methods?.errors}
                    register={methods?.register}
                    rules={['required']}
                    placeholder="جستجو و انتخاب کنید..."
                    name="businesses"
                    label="شناسه کسب‌ و کار"
                    list={businesses}
                    loading={loadingAuth}
                    getOptionSelected={(option, value) => option.id === value.id}
                    getOptionDisabled={(option) =>
                      singleSelect ? selected : selected?.find((v) => v?.id === option?.id) != null
                    }
                    //
                    onInputChange={(_, inputValue, reason) => {
                      if (reason === 'input') {
                        setBusinessSearchText(inputValue ?? '');
                      }

                      if (reason === 'clear') {
                        setBusinessSearchText('');
                        setFValue(null);
                        methods.setValue('businesses', null);
                      }
                    }}
                    onChangeValue={(p) => {
                      setFValue(p?.id ?? null);
                      setBusinessSearchText('');
                      if (!p) return;
                      if (singleSelect) {
                        setSelected(p);
                      } else {
                        const temp = [...selected];
                        temp.push(p);
                        setSelected([...temp]);
                      }

                      if (methods?.setValue) {
                        methods.setValue('businesses', p, { shouldValidate: true });
                      }
                    }}
                    //
                    preventAddCustomOption
                    disableClearable={!singleSelect}
                    //
                    {...rest}
                  />
                </Grid>
              )}
              {grantTypeOptions.find((v) => v?.value === grantUserDataType)?.value !==
                'businessId' && (
                <Grid item xs={12} md={6}>
                  <InputV2
                    control={control}
                    register={register}
                    errors={errors}
                    rules={[
                      'required',
                      ...grantTypeOptions.find((v) => v?.value === grantUserDataType)?.rules,
                    ]}
                    englishNumber={
                      grantTypeOptions.find((v) => v?.value === grantUserDataType)?.englishNumber
                    }
                    name="contact"
                    label={grantTypeOptions.find((v) => v?.value === grantUserDataType)?.label}
                    mainStyle={{ width: '100%', marginLeft: 0, marginRight: 0 }}
                    fullWidth
                    dir="ltr"
                    placeholder=""
                    defaultValue={userContactInfo ?? ''}
                    disabled={incomingUserQuery?.userInfo}
                    onChangeValue={(e) => {
                      setUserContactInfo(e.currentTarget.value);
                    }}
                  />
                </Grid>
              )}
            </Grid>
            <Grid xs={12} container spacing={2} style={{ marginBottom: 5 }}>
              <Grid item xs={12}>
               
                <AutocompleteV
                  control={methods?.control}
                  errors={methods?.errors}
                  register={methods?.register}
                  placeholder="جستجو و انتخاب کنید..."
                  name="otherData"
                  id="comparativeAccount"
                  list={otherData}
                  loading={loadingAuth}
                  getOptionSelected={(option, value) => option.url === value.url}
                  getOptionDisabled={(option) => option.url}
                  //
                  onInputChange={(params) => (
                    <TextField {...params} variant="outlined" label="یک آدرس  بازگشت انتخاب کنید" />
                  )}
                  onChangeValue={(newValue) => {
                    setRedirectUri(newValue?.url ?? null);
                  }}
                  //
                  preventAddCustomOption
                  clearOn={!singleSelect}
                  disableClearable={!singleSelect}
                  //
                  {...rest}
                />
              </Grid>
            </Grid>
            <Grid xs={12} spacing={2} container>
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={() => getShareLink()}
                  disabled={
                    grantUserDataType == 'businessId'
                      ? !fValue
                      : !userContactInfo || userContactInfo.length <= 3
                  }
                >
                  {loading ? 'لطفا صبر کنید' : 'دریافت لینک'}
                </Button>
              </Grid>
            </Grid>
          </>
        ) : null}

        {link ? (
          <>
            <Grid xs={12} item style={{ marginBottom: 5 }}>
              <TextField
                style={{ direction: 'ltr', textAlign: 'center' }}
                fullWidth
                variant="outlined"
                value={link}
                disabled
              />
            </Grid>

            <Grid xs={12} item style={{display: 'flex', flexDirection: 'row-reverse', marginTop: '16px' ,  gap: '15px',}}>
              <Button variant="contained" color="primary" fullWidth onClick={() => copyItem(link)}>
                کپی کردن لینک
              </Button>
            </Grid>
          </>
        ) : null}
      </Grid>
    </>
  );
};

const useStyle = makeStyles(() => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column !important',
  },
  searchBusinessId: {
    height: '40px',
    margin: ' 5px 0',
  },
  title: { fontSize: '1.5em' },
  textWrapper: {
    marginTop: '1em',
  },
  button: {
    marginTop: '1em',
  },
  shareLinks: {
    marginTop: '1em',
    textAlign: 'center',
  },
  shareLink: {
    marginLeft: '.5em',
    color: 'white',
  },
}));
